import { appLocalStorage } from '@/app/shared/commonURLs';

let ScreeningUrl = appLocalStorage.ScreeningUrl;
let MedicalHistoryUrl = appLocalStorage.MedicalHistoryUrl;
//let ScreeningODataUrl = appLocalStorage.ScreeningODataUrl;
let PatientProblemUrl = appLocalStorage.PatientProblemURL;
let ProductManagementODataUrl = appLocalStorage.ProductManagementODataUrl;
let ProductManagementUrl = appLocalStorage.ProductManagementUrl;
let allergyURl = appLocalStorage.AllergyServiceUrl;

export class uRls {
    constructor() {
        debugger
        this.screeningServicesList = URls();
    }
}

const ScreeningModuleURL = new uRls();

export { ScreeningModuleURL };


function URls() {
    var services = {};
    services["GenericRetrieval"] = {
        Method: 'Get',
        URL: ScreeningUrl + 'Generic/GenericRetrieval',
    }
    //services["GetPatientDiease"] = {
    //    Method: 'Get',
    //    URL: ScreeningUrl + 'Questionnaire/GetPatientDiease',
    //}

    services["GetPatientDiease"] = {
        Method: 'Get',
        URL: PatientProblemUrl + 'PatientProblem/GetPatientBannerDiseases',
    },
        services["GetAllDiseases"] = {
            Method: 'Get',
            URL: ScreeningUrl + 'Questionnaire/GetAllDiseases',
        }
        , services["GetPatientFamilyHistory"] = {
            Method: 'Get',
        URL: MedicalHistoryUrl + 'MedicalHistory/GetPatientFamilyHistory?',
        },
        services["GetAllContraception"] = {
            Method: 'Get',
        URL: ScreeningUrl + 'Questionnaire/GetAllContraception',
        },
    services["GetSocialLookUpList"] = {
        Method: 'Get',
        URL: ScreeningUrl + 'Questionnaire/GetSocialLookUpList',
        }
    services["GetSocialMedicalHistory"] = {
        Method: 'Get',
        URL: MedicalHistoryUrl + 'SocialMedicalHistory/GetPatientSocialHistory?',
    }
    services["GetPatientSurgicalHistory"] = {
        Method: 'Get',
        URL: MedicalHistoryUrl + 'SurgicalMedicalHistory/GetPatientSurgicalHistory?',
    }
    services["ProductByClassificationOData"] = {
        Method: 'GET',
        URL: ProductManagementODataUrl + 'ProductByClassificationOData?'
    }
        
      services["GetPatientMedicationHistory"] = {
            Method: 'Get',
        URL: MedicalHistoryUrl + 'MedicalHistory/GetPatientMedicationHistory?',
    }

    services["GetPatientAllergies"] = {
        Method: 'Get',
        URL: allergyURl + 'PatientAllergy/GetPatientAllergies?',
    }
    services["GetAllergyLookUpList"] = {
        Method: 'Get',
        URL: ScreeningUrl + 'Questionnaire/GetAllergyLookUpList',
    }
    
    services["GetMedicationLookUp"] = {
        Method: 'Get',
        URL: ScreeningUrl + 'Questionnaire/GetMedicationLookUp',
    }
    services["GetMedications"] = {
        Method: 'Get',
        URL: ProductManagementUrl + 'Product/GetMedications',
    }
    services["MedicationOData"] = {
        Method: 'GET',
        URL: ProductManagementODataUrl + 'MedicationOData?'
    }
    services["GenericRetrieval"] = {
        Method: 'Get',
        URL: ProductManagementUrl + 'Generic/GenericRetrieval',
    }
    services["GetPatientObGyn"] = {
        Method: 'Get',
        URL: MedicalHistoryUrl + 'ObsGynMedicalHistory/GetPatientObGyn?',
    }

    services["SavePatientQuestionnaire"] = {
        Method: 'Post',
        URL: ScreeningUrl + 'Questionnaire/SavePatientQuestionnaire',
    }
    services["GetObsGynLookup"] = {
        Method: 'Get',
        URL: MedicalHistoryUrl + 'ObsGynMedicalHistory/GetObsGynLookup?',
    }
    return services
}